import BenchlingConfig from 'BenchlingConfig';
import {TagSchemaItemType} from 'graphql-client/__generated/graphqlGlobalTypes';

/**
 * Context available for determining whether to show submenu items
 */
export interface SubmenuContext {
  itemType: TagSchemaItemType | null;
}

/**
 * A simple predicate function that determines if a submenu should be shown
 */
export type SubmenuPredicate = (context: SubmenuContext) => boolean;

/**
 * Helper to check if a schema is an antibody schema
 */
export function isAntibodySchema(context: SubmenuContext): boolean {
  return context.itemType === TagSchemaItemType.ANTIBODY;
}

/**
 * Predicate for showing antibody domains submenu
 * Shows for antibody schemas
 */
export function shouldShowAntibodyDomains(context: SubmenuContext): boolean {
  return isAntibodySchema(context);
}

/**
 * Predicate for showing antibody chains submenu
 * Shows for antibody schemas when antibody chains are enabled
 */
export function shouldShowAntibodyChains(context: SubmenuContext): boolean {
  return BenchlingConfig.MOLBIO_ENABLE_ANTIBODY_CHAINS && isAntibodySchema(context);
}

/**
 * Helper function to conditionally include submenus based on context
 */
export function conditionalSubmenu(
  submenu: {
    sectionHeader: string;
    namePartTypes: Array<import('graphql-client/__generated/graphqlGlobalTypes').NameTemplatePartType>;
  },
  predicate: SubmenuPredicate,
  context: SubmenuContext
): Array<typeof submenu> {
  return predicate(context) ? [submenu] : [];
}
